import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full py-14 md:py-20 bg-primary-500">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-white">
          准备好深入探索火影同人世界了吗？
        </h2>
        <p className="mt-4 text-sm md:text-base text-white/80 max-w-xl mx-auto">
          从角色设定到画风流派，从创作技巧到收藏指南，与万千火影粉丝一起探索同人文化的无限可能。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/creation-tips"
            className="whitespace-nowrap bg-white text-primary-600 px-8 py-3 rounded-full font-medium text-sm hover:bg-white/90 transition-colors cursor-pointer"
          >
            开始创作之旅
          </Link>
          <Link
            to="/about"
            className="whitespace-nowrap bg-primary-600 text-white px-8 py-3 rounded-full font-medium text-sm hover:bg-primary-700 transition-colors cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}